import { ThunkAction } from 'redux-thunk';

import { TRootState } from '@/redux/rootReducer';
import apiRequest from '@/services/apiRequest';
import { IMinimumStay } from '@/services/types/search/minimumStay';
import { getCoreApi } from '@/utility/getCoreApi';
import { getMinimumStayDateRange } from '@/utility/minimumStay';
import { IAction } from '@/utility/redux/action';

const FETCH_MINIMUM_STAY_SUCCESS = 'minimumStay/FETCH_MINIMUM_STAY_SUCCESS';
const FETCH_MINIMUM_STAY_FAILURE = 'minimumStay/FETCH_MINIMUM_STAY_FAILURE';

interface IFetchMinimumStaySuccessAction extends IAction {
  type: typeof FETCH_MINIMUM_STAY_SUCCESS;
  payload: IMinimumStay;
}

interface IFetchMinimumStayFailureAction extends IAction {
  type: typeof FETCH_MINIMUM_STAY_FAILURE;
}

type TAction = IFetchMinimumStaySuccessAction | IFetchMinimumStayFailureAction;

const fetchMinimumStaySuccess = (payload: IMinimumStay): IFetchMinimumStaySuccessAction => ({
  type: FETCH_MINIMUM_STAY_SUCCESS,
  payload,
});

const fetchMinimumStayFailure = (): IFetchMinimumStayFailureAction => ({
  type: FETCH_MINIMUM_STAY_FAILURE,
});

export const getMinimumStay =
  (rentalId: string): ThunkAction<Promise<TAction>, TRootState, void, TAction> =>
  dispatch => {
    const { fromDate, toDate } = getMinimumStayDateRange();
    const requestUrl = `${getCoreApi()}/rentals/${rentalId}/minimum-stay?from=${fromDate}&to=${toDate}`;

    // rejectOnError: a failed/404'd fetch must surface as an explicit error so the
    // resolver can fall back to active_options.minimum_days, not silently succeed.
    return apiRequest<IMinimumStay>({ url: requestUrl }, true)
      .then(data => dispatch(fetchMinimumStaySuccess(data)))
      .catch(() => dispatch(fetchMinimumStayFailure()));
  };

interface IState {
  data: IMinimumStay | undefined;
  isFetched: boolean;
  error: boolean;
}

export const initialState: IState = {
  data: undefined,
  isFetched: false,
  error: false,
};

export default function reducer(state = initialState, action: TAction): IState {
  switch (action.type) {
    case FETCH_MINIMUM_STAY_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isFetched: true,
        error: false,
      };
    case FETCH_MINIMUM_STAY_FAILURE:
      return {
        ...state,
        isFetched: true,
        error: true,
      };
    default:
      return state;
  }
}
